/**
 * @fileoverview The empty page of a collection with nothing in it yet: one sentence and the
 * way in, in a centred column. Shared so the Plants page and the Beds page
 * look and behave the same when they are empty.
 *
 * Where: PlantGrid (no plants) and LocationGrid (no beds).
 * Watch out: the page around it is also narrowed to max-w-xl while empty, so
 * the toolbar and bar above do not stretch across a desktop.
 *
 * @module EmptyGarden
 */

import React from 'react';

/** The sentence and the buttons under it. */
interface EmptyGardenProps {
  /** What is missing, in one sentence. */
  message: string;
  /** The way in: the buttons that start the first one. */
  children: React.ReactNode;
}

/**
 * A sentence and the first steps, centred.
 *
 * @param props - The sentence and the buttons.
 * @returns {JSX.Element} The empty state.
 */
export const EmptyGarden: React.FC<EmptyGardenProps> = ({ message, children }) => (
  <div className="mx-auto max-w-md py-6 text-center">
    <p className="text-muted-foreground">{message}</p>
    <div className="mt-4 flex flex-wrap justify-center gap-2">{children}</div>
  </div>
);
